<template>
  <div class="row help-wrapper">
    <!-- <header-about /> -->
    <div id="corpo" class="col s12">
      <div class="col s12 input-field">
        <div class="switch">
          <span style="font-size: 1.5rem">BIOMETRIA</span>
          <label class="right">
            <input @change="setPersistentLogin" v-model="persistent_login_active" type="checkbox">
            <span class="lever"></span>
          </label>
        </div>
        <hr />
      </div>
      <div class="col s12">
        <br />
        <br />
        <br />
      </div>
      <div class="col s12">
        <p>
          A biometria é usada apenas para acessar o aplicativo. O Recad Censo não coleta,
          trata ou armazena esses dados. Eles são utilizados apenas no aparelho e segue os 
          termos de uso e as políticas de privacidade do fabricante.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderAbout from "@/components/HeaderAbout.vue"
import {clearPersistentLogin} from '@/assets/js/scripts-login.js'
export default {
  name: 'Sobre',
  components: {
    "header-about": HeaderAbout,
  },
  data (){
    return {
      active_step: 1,
      last_page: this.$store.state.route.from.fullPath,
      persistent_login_active: true
    }
  },
  methods: {
    setPersistentLogin(cpf, nascimento, oid){
      if(this.biometry_available == 'touch'){
        TouchID.isAvailable()
        .then(
          () => {
            TouchID.verifyFingerprint('Deseja usar a sua digital para se autenticar?')
            .then(
              () => {
                localStorage.setItem('cpf', cpf)
                localStorage.setItem('nascimento', nascimento)
                localStorage.setItem('oid', oid)
              },
              (err) => err
            )
          },
          (e) => e
        )
      }
    },
    verificaLoginPersistente(){
      try {
        let cpf = (localStorage.getItem('cpf') && validaCPF(localStorage.getItem('cpf')) === true ? localStorage.getItem('cpf') : false)
        let nascimento = (localStorage.getItem('nascimento') && verificaData(localStorage.getItem('nascimento'), "YYYY-MM-DD") === true ? localStorage.getItem('nascimento') : false)
        let oid = (localStorage.getItem('oid') ? localStorage.getItem('oid') : false)

        return (cpf && nascimento && oid ? true : false)
      } catch (e) {
        clearPersistentLogin()
      }
      return false
    },
    initMaterialize() {
      setTimeout(() => {
        M.Collapsible.init((document.querySelectorAll('.collapsible')))
        M.Materialbox.init(document.querySelectorAll('.materialboxed'))
      }, 100)
    }
  },
  mounted(){
    this.$root.$emit('stopLoadingHeader')
    this.initMaterialize()
    this.persistent_login_active = this.verificaLoginPersistente()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Biometria.vue